import { render, staticRenderFns } from "./Copro_Navbar.vue?vue&type=template&id=ba46f9ee&scoped=true"
import script from "./Copro_Navbar.vue?vue&type=script&lang=js"
export * from "./Copro_Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba46f9ee",
  null
  
)

export default component.exports